import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Textfield from "../components/Textfield";

import Button from "./Buttons";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";

const OtpModal = ({ success, otpText, otpDetailText, buttonLabel }) => {
  return (
    <OtpModalStyled>
      <InnerDiv>
        <Logo src={require("../assets/images/logo.png")} alt="logo" />
        <OtpForm>
          <OtpLogo
            src={
              success
                ? require("../assets/images/success-tick.png")
                : require("../assets/images/success-tick.png")
            }
          />
          {success && <OtpText>{otpText}</OtpText>}
          <OtpSubText>{otpDetailText}</OtpSubText>
          <AddSpace>
            <Button
              label={buttonLabel}
              variant="filled"
              color={Colors.aqua}
              size="large"
              // onClick={(e) => handleSubmit(e)}
            />
          </AddSpace>
        </OtpForm>
      </InnerDiv>
    </OtpModalStyled>
  );
};

export default OtpModal;

const OtpModalStyled = styled.div`
  width: 31.7rem;
  border-radius: 0.5rem;
  background:red;
  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Logo = styled.img`
  height: 4rem;
  resize: contain;
`;
const OtpForm = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0rem 6rem 0rem 6rem;
  margin-top: 1rem;
  box-sizing: border-box;
  align-items: center;
  @media only screen and (max-width: 540px) {
    padding: 0rem 4rem 0rem 4rem;
  }
  @media only screen and (max-width: 300px) {
    padding: 0rem 2rem 0rem 2rem;
  }
`;
const OtpLogo = styled.img`
  width: 6rem;
  height: 6rem;
  resize: contain;
`;
const OtpText = styled.span`
  color: ${Colors.blackSqueeze};
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 1rem;
`;
const OtpSubText = styled.span`
  color: ${Colors.approxSnow};
  text-align: center;
  font-size: 1rem;
  font-weight: 400;
`;

const AddSpace = styled.span`
  width: 100%;
  margin-top: 1.5rem;
  margin-bottom: 4rem;
  @media only screen and (max-width: 768px) {
    width: 80%;
  }
  @media only screen and (max-width: 640px) {
    width: 100%;
  }
`;
